/**
 * Scroll To Top Component
 * 
 * Scrolls to top on route change, but preserves scroll position for back/forward navigation.
 * Uses the navigation type to determine whether to scroll to top.
 * Also enables the browser's native scroll restoration for POP navigations.
 */

import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const prevPathnameRef = useRef(pathname);
  
  // Enable manual scroll restoration (we handle it ourselves)
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      // Use 'auto' for browser-native scroll restoration on back/forward
      window.history.scrollRestoration = 'auto';
    }
  }, []);
  
  useEffect(() => {
    // Only scroll to top on PUSH navigation (not POP/back or REPLACE)
    // This preserves scroll position when using browser back/forward
    if (navigationType === 'PUSH' && pathname !== prevPathnameRef.current) {
      // Use setTimeout to ensure DOM has updated
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }, 0);
    }
    
    prevPathnameRef.current = pathname;
  }, [pathname, navigationType]);
  
  return null;
};

export default ScrollToTop;
